/**
 * GENERATED FILE. Do not edit.
 *
 * Source: packages/shared/src/manifest (the capability manifest's entries)
 * Rebuild: bun run manifest:build
 */

/** The first 12 hex characters of SHA-256 over the manifest's canonical entries. */
export const MANIFEST_VERSION = '69078c3663e2';
